import {
    FETCH_NOTIFICATIONS_REQUEST,
    FETCH_NOTIFICATIONS_SUCCESS,
    FETCH_NOTIFICATIONS_FAILURE,
  } from "./FetchNotificationsTypes";
  
  const initialState = {
    loading: false,
    notifications: [],
    error: "",
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_NOTIFICATIONS_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_NOTIFICATIONS_SUCCESS:
        return {
          loading: false,
          notifications: action.payload,
          error: "",
        };
      case FETCH_NOTIFICATIONS_FAILURE:
        return {
          loading: false,
          notifications: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  